import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CHECKOUT_SESSION_KEYS } from 'V2/Checkout/constants';
import { CheckoutPageLayout } from 'V2/Checkout/components';
import { UWConsentStep } from './components/UWConsentStep';
import { PaymentStep } from './components/PaymentStep';
import styles from './styles.module.css';

export const CheckoutPayment: React.FC = () => {
  const history = useHistory();

  const appId = sessionStorage.getItem(CHECKOUT_SESSION_KEYS.appId) ?? '';
  const paymentPlanId =
    sessionStorage.getItem(CHECKOUT_SESSION_KEYS.paymentPlanId) ?? '';
  const quoteId = sessionStorage.getItem(CHECKOUT_SESSION_KEYS.quoteId) ?? '';

  const [uwAgreed, setUwAgreed] = useState(false);
  const [bindDecisionMessage, setBindDecisionMessage] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (!appId || !paymentPlanId || !quoteId) {
      history.replace('/search');
    }
  }, [appId, paymentPlanId, quoteId, history]);

  if (bindDecisionMessage) {
    return (
      <CheckoutPageLayout>
        <p className={styles.terminalMessage} role="alert">
          {bindDecisionMessage}
        </p>
      </CheckoutPageLayout>
    );
  }

  return (
    <CheckoutPageLayout>
      <p className={styles.subtitle}>
        Please review and complete the following to confirm your purchase
      </p>
      {!uwAgreed && (
        <UWConsentStep appId={appId} onAgreed={() => setUwAgreed(true)} />
      )}
      {uwAgreed && (
        <PaymentStep
          appId={appId}
          paymentPlanId={paymentPlanId}
          onBindDecision={setBindDecisionMessage}
        />
      )}
    </CheckoutPageLayout>
  );
};
